import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { DEVTOOLS_OPTIONS } from '@/modules/debug/constants/zustand';
import { Status, Step } from '../types';

export type Store = {
  step: Step;
  status: Status;
};

const INITIAL_STATE: Store = {
  step: Step.Validate,
  status: Status.Idle,
};

type Actions = {
  setStep(step: Step): void;
  setStatus(status: Status): void;
  reset(): void;
};

export const useFpsStore = create<Store & Actions>()(
  devtools(
    (set) => ({
      ...INITIAL_STATE,

      setStep(step) {
        set(
          {
            step,
          },
          undefined,
          {
            type: 'setStep',
          },
        );
      },

      setStatus(status) {
        set(
          {
            status,
          },
          undefined,
          {
            type: 'setStatus',
          },
        );
      },

      reset() {
        set(INITIAL_STATE, undefined, {
          type: 'reset',
        });
      },
    }),
    { store: 'fpsStore', ...DEVTOOLS_OPTIONS },
  ),
);
